import React, { Component, PropTypes } from 'react';
import { Toolbar, Styles, ToolbarGroup, ToolbarTitle } from 'material-ui';
import ToolbarIconButton from 'components/Material/ToolbarIconButton';
import DropZone from 'components/DropZone';
import FileUpload from 'components/Widgets/FileUpload';
import * as Icons from 'components/Material/SvgIcons';
import Message from 'services/Message';
import { MediaLibraryActions } from 'actions';
import { history } from 'helpers';

import CircularProgress from 'components/Material/CircularProgress';

const { Spacing } = Styles;

const styles = {
  root: {
    backgroundColor: '#FFF'
  },
  remaining: {
    fontSize: 24,
    textAlign: 'center',
    padding: Spacing.desktopGutter
  }
};

class MediaLibraryUpload extends Component {
  static displayName = 'MediaLibraryUpload';

  static contextTypes = {
    getIntlMessage: PropTypes.func,
    muiTheme: PropTypes.object
  };

  state = {
    progress: 0,
    remaining: 0
  };

  progress(event) {
    this.setState({
      progress: Math.floor(event.percent),
      remaining: event.remaining
    });
  }

  attach(files, e) {
    this.setState({ progress: 0 });
    Message.info(this.context.getIntlMessage('mediaLibrary.uploadComplete'));
    MediaLibraryActions.moveFiles(files);
  }

  goBack() {
    history.goBack();
  }

  render() {
    const description = this.context.getIntlMessage('mediaLibrary.dropHere');

    let progress;

    if (this.state.progress > 0) {
      progress = (
        <div>
          <div
            style={{
              margin: 'auto',
              textAlign: 'center',
              lineHeight: Spacing.desktopKeylineIncrement * 4 + 'px'
            }}
          >
            <CircularProgress
              progressColor={
                this.context.muiTheme.rawTheme.palette.primary1Color
              }
              progress={this.state.progress}
              size={2}
            />
          </div>
          <div style={{ textAlign: 'center' }}>
            {this.context.getIntlMessage('mediaLibrary.Uploading')}
          </div>
        </div>
      );
    }
    let busy = this.state.remaining > 0 || this.progress > 0;
    return (
      <div>
        <Toolbar>
          <ToolbarGroup float={'left'} key={0}>
            <ToolbarTitle
              text={this.context.getIntlMessage('mediaLibrary.Upload')}
            />
          </ToolbarGroup>
          {!busy && (
            <ToolbarGroup float={'right'} key={1}>
              <ToolbarIconButton
                tooltip={this.context.getIntlMessage('Close')}
                tooltipPosition="bottom-center"
                svgIcon={<Icons.ContentClear />}
                onTouchTap={::this.goBack}
              />
            </ToolbarGroup>
          )}
        </Toolbar>
        {this.state.remaining > 0 && (
          <div style={styles.remaining}>
            {this.state.remaining}{' '}
            {this.context.getIntlMessage('mediaLibrary.filesRemaining')}
          </div>
        )}
        {progress}
        {!busy && (
          <div>
            <div
              style={{ margin: Spacing.desktopGutterMore, textAlign: 'center' }}
            >
              <DropZone
                height={300}
                width={'100%'}
                lineHeight={300}
                onProgress={this.progress.bind(this)}
                onSuccess={this.attach.bind(this)}
                multiple={true}
              >
                {description}
              </DropZone>
              <p style={{ margin: Spacing.desktopGutter, padding: 0 }}>
                {this.context.getIntlMessage('or')}
              </p>
              <FileUpload
                multiple={true}
                fullWidth={true}
                className={'upload-button'}
                onProgress={this.progress.bind(this)}
                onSuccess={this.attach.bind(this)}
                secondary={true}
                label={this.context.getIntlMessage('mediaLibrary.uploadFiles')}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default MediaLibraryUpload;



// WEBPACK FOOTER //
// ./src/js/components/MediaLibrary/MediaLibraryUpload.js